module.exports = __webpack_public_path__ + "static/media/terminator2.b8e9c4f8.png";